import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getPaymentPaymentsGroup } from '../../services/payments';
import useCheckoutState from '../checkouts/useCheckoutState';

function useGetPaymentPaymentsGroup(paymentId: string | null | undefined) {
  const { user } = useUser();
  const { selectedPaymentsGroup, setSelectedPaymentsGroup } =
    useCheckoutState();

  const {
    data,
    isLoading,
    isFetching,
    isError,
    isPlaceholderData,
    error,
    refetch,
  } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      'payment-payments-group',
      paymentId,
      user?.userId,
      user?.business?.id,
    ],
    queryFn: async () => {
      const result = await getPaymentPaymentsGroup({ paymentId: paymentId! });

      if (
        selectedPaymentsGroup &&
        setSelectedPaymentsGroup &&
        result.groupKey === selectedPaymentsGroup.groupKey
      ) {
        setSelectedPaymentsGroup(result);
      }

      return result;
    },
    enabled: !!paymentId && !!user?.userId && !!user?.business?.id,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    isPlaceholderData,
    error,
    refetch,
  };
}

export default useGetPaymentPaymentsGroup;
